<template>
    <div class="container mx-auto mb-60px">
        <div class="flex flex-col md:flex-row-reverse gap-4 mx-4">
            <div class="w-full">
                <SectionSlotLgComponent 
                    :article="main"
                    :slug="slug"
                    classes="highlight" />
            </div>

            <div class="w-full grid gap-4 md:grid-cols-2" dir="rtl">
                <!-- <div class="bg-gray-200">SM1</div>
                <div class="bg-gray-200">SM2</div>
                <div class="bg-gray-200">SM3</div>
                <div class="bg-gray-200">SM4</div> -->
                <SectionSlotSmComponent
                    v-for="article,articleIndex in subs"
                    :key="articleIndex"
                    :article="article"
                    :slug="slug" />
            </div>

            <!-- 

                <div class="w-full flex flex-col md:flex-row-reverse md:flex-wrap -mx-4">
                <div class="md:w-1/2 md:h-auto md:p-4">
                    <div class="bg-gray-200 w-full h-full">SM1</div>
                </div>
                <div class="md:w-1/2 md:h-auto md:p-4">
                    <div class="bg-gray-200 w-full h-full">SM2</div>
                </div>
                <div class="md:w-1/2 md:h-auto md:p-4">
                    <div class="bg-gray-200 w-full h-full">SM3</div>
                </div>
                <div class="md:w-1/2 md:h-auto md:p-4">
                    <div class="bg-gray-200 w-full h-full">SM4</div>
                </div>
            </div>

             -->
        </div>

        <!-- <div class="flex mx-5 mb-30px">
            <SectionSlotLgComponent 
                :article="main"
                :slug="slug"
                classes="highlight" />
        </div>

        <div class="mx-5 overflow-hidden">
            <div class="w-full md:w-1/2 mx-4 overflow-hidden">
                <div class="flex flex-wrap flex-row-reverse col2-list-dashed -m-4">
                    <SectionSlotSmComponent
                        v-for="article,articleIndex in subs"
                        :key="articleIndex"
                        :article="article"
                        :slug="slug"
                        classes="w-1/2" />
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import SectionSlotLgComponent from './Slots/SectionSlotLgComponent.vue'
import SectionSlotSmComponent from './Slots/SectionSlotSmComponent.vue'

export default{
    props: ['data', 'slug'],
    computed: {
        main() {
            const main = this.data.splice(0, 1)
            return main.length > 0 ?
                main[0] :
                null
        },
        subs() {
            return this.data
        }
    },
    components: {
        SectionSlotLgComponent,
        SectionSlotSmComponent,
    }
}
</script>